import update from 'immutability-helper'
import {sortBy} from 'lodash'
import fetch from 'helpers/command'
import {updateLoadableList} from 'helpers/context'
import moment from 'moment'

const hooks =  [
    {paths: ['page/', 'query/', 'homeworkContext/homeworks/refreshes'], fetches:[getHomeworks]},
    {paths: ['page/', 'homeworkId/', 'homeworkContext/studentHomeworkStatus/refreshes'], fetches:[getStudentHomeworkStatus]}
]

export {hooks as default}

export async function getHomeworks({page, query, updateState}) {
    if (page != 'homework') return 
    updateState(updateLoadableList('homeworkContext.homeworks'))
    const items = await fetch('homework', 'getHomeworks')({...query})
    items.reverse()
    const addTurnIns = h => ({
      ...h,
      turnIns: h.students.filter(s => s.properties.files && s.properties.files.length > 0).length
    })
    updateState(updateLoadableList('homeworkContext.homeworks', items.map(addTurnIns)))
}

export async function getStudentHomeworkStatus({page, homeworkId, updateState}) {
    if (page != 'homework' || !homeworkId) return 
    updateState(updateLoadableList('homeworkContext.studentHomeworkStatus'))
    const status = await fetch('homework', 'getStudentHomeworkStatus')({id: homeworkId})
    const sortedFeedbackStatuses = status.map(s => {
        const sorted = update(s, {status: {$apply: a => sortBy(a, a => moment(a.created).valueOf())}})
        return sorted
    })
    updateState(updateLoadableList('homeworkContext.studentHomeworkStatus', sortedFeedbackStatuses))
}

